// ============================================================
// portfolioData.js — All portfolio content in one place
// ============================================================

export const personalInfo = {
  name: "Chandan Gupta",
  title: "Full Stack Developer & DevOps",
  website: "https://chandanprofile.com",
  email: "mynameischandangupta1@gmail.com",
  email2: "mrguptachandan@gmail.com",
  phone: "+44 7876128289",
  phone2: "+91 8743870503",
  address:
    "12 Magpie Walk, Hatfield, UK  |  Ward No 6, Nichlaul Maharajganj, Pin: 273304",
  cvLink:
    "https://drive.google.com/file/d/1PMSM2EN4XA8x-YIz_kc1uWxrMJD61AtM/view?usp=sharing",
  profileImage: "/images/passport_pic_100kb.jpg",
  social: {
    facebook: "https://www.facebook.com/chandanrss",
    twitter: "",
    instagram: "https://www.instagram.com/chandanrss",
    linkedin: "https://www.linkedin.com/in/chandanrss",
    github: "https://github.com/chandanrss",
  },
};

export const heroSlides = [
  {
    id: 1,
    image: "/images/office_pic_1.jpg",
    bgPos: "center center",
    heading: "Hi!\nI'm Chandan",
    subheading: "Specialized in Coding and Learning New Technology",
  },
  {
    id: 2,
    image: "/images/office_pic_2.webp",
    bgPos: "50% 20%",
    heading: "I am\na Fullstack Developer",
    subheading: "Doctor of Technology",
  },
];

export const aboutText = [
  "Hi, I'm Chandan Gupta — a passionate Full Stack Developer with over 5 years of professional experience in building scalable web and e-commerce solutions. I enjoy managing projects and leading cross-functional teams more than just writing code, and I thrive in roles that allow me to contribute to both development and strategic planning.",
  "I am currently pursuing an MSc in Advanced Computer Science at the University of Hertfordshire, UK, which is sharpening my skills in system design, networking, and modern development practices.",
  "Organized and highly motivated, I bring strong coding expertise, time management, and problem-solving abilities to every project I work on. I'm looking to grow within a fast-paced, technology-driven company where I can combine my passion for innovation with a people-first, collaborative mindset.",
];

export const specialties = [
  {
    id: 1,
    icon: "fa-mobile-alt",
    color: "color-2",
    title: "AI/ML Software Developers",
  },
  {
    id: 2,
    icon: "fa-lightbulb",
    color: "color-1",
    title: "Devops / Networking & Configuration",
  },
  {
    id: 3,
    icon: "fa-database",
    color: "color-3",
    title: "SQl and NoSql",
    subtitle: "(MYSQL, MONGO)",
  },
  {
    id: 4,
    icon: "fa-globe",
    color: "color-2",
    title: "Web-App Development",
    subtitle: "(MEAN, MERN, PHP)",
  },
];

export const achievements = [
  {
    id: 1,
    icon: "fa-link",
    color: "color-3",
    title: "Course Certification",
    description: "Data Structure Certification on Udemy (April- 2025)",
  },
  {
    id: 2,
    icon: "fa-link",
    color: "color-1",
    title: "Awarded",
    description:
      "Award of Excellence in Annual Meet Nasik - 2022 (Docfliq Pvt Ltd)",
  },
  {
    id: 3,
    icon: "fa-link",
    color: "color-2",
    title: "AWS Certification",
    description:
      "Solutions Architect Associate Certification on Udemy (Nov- 2023)",
  },
  {
    id: 4,
    icon: "fa-link",
    color: "color-3",
    title: "Course Certification",
    description:
      "Successfully Completed PHP Advance Course from NIIT and DUCAT (Noida)",
  },
];

export const counters = [
  { id: 1, end: 409, label: "Cups of Coffee" },
  { id: 2, end: 7, label: "Projects" },
  { id: 3, end: 5, label: "Clients" },
];

export const skills = [
  { id: 1, name: "JS/TS (MERN and MEAN)", level: 85, colorClass: "color-1" },
  {
    id: 2,
    name: "PHP (Laravel, Zend, Cake-Php)",
    level: 90,
    colorClass: "color-2",
  },
  { id: 3, name: "Devops (CI/CD)", level: 75, colorClass: "color-3" },
  { id: 4, name: "MYSQL and MONGO", level: 80, colorClass: "color-4" },
  { id: 5, name: "HTML, CSS, XML", level: 80, colorClass: "color-5" },
  { id: 6, name: "Linux, Shell, CLI", level: 90, colorClass: "color-6" },
  { id: 7, name: "AI & Machine Learning", level: 65, colorClass: "color-3" },
];

export const education = [
  {
    id: 1,
    degree: "MSc in Advanced Computer Science (Completed Oct 2025)",
    institution: "University of Hertfordshire (UH), Hatfield, United Kingdom.",
    year: "2024 – 2025",
    description: [
      "Master of Science in Advanced Computer Science from University of Hertfordshire (UH), Hatfield, United Kingdom.",
      "I successfully completed my MSc in Advanced Computer Science in October 2025 to strengthen my expertise in modern and emerging technologies. The programme provided in-depth knowledge through core modules such as Wireless Technology, Networking, Data Structures & Algorithms (DSA), and Machine Learning, offering a strong foundation in modern communication systems and efficient data transmission.",
      "These modules enhanced my understanding of today's interconnected digital ecosystem, including mobile networks, cloud-based systems, and IoT architectures. This learning aligns closely with my interest in developing intelligent and autonomous systems, particularly in areas such as AI-driven applications and robotics.",
      "Additionally, the Computational Programming module significantly strengthened my problem-solving and advanced coding skills.",
    ],
  },
  {
    id: 2,
    degree: "Bachelor Degree of Computer Science",
    institution:
      "AKTU (Dr. A.P.J. Abdul Kalam Technical University), Uttar Pradesh",
    year: "2014 – 2018",
    description: [
      "Graduated in 2018 with distinction in Computer Science and Engineering from AKTU (Dr. A.P.J. Abdul Kalam Technical University), Uttar Pradesh, achieving a 1st division.",
      "My academic journey has equipped me with a solid foundation in computer science principles, programming languages, and problem-solving skills.",
      "Premium Member of Coder Clan Club of Coding. Organized Several Coding Events and Classes for Free.",
    ],
  },
  {
    id: 3,
    degree: "Intermediate (12th)",
    institution: "Gorakhpur",
    year: "2012 – 2014",
    description: ["2012 - 2014 Gorakhpur"],
  },
  {
    id: 4,
    degree: "High School",
    institution: "Gorakhpur",
    year: "2010 – 2012",
    description: ["2010 - 2012 Gorakhpur"],
  },
];

export const experience = [
  {
    id: 1,
    role: "ML / AI Master's Level Internship",
    company: "Vosyn · Remote",
    companyUrl: "https://vosyn.ai",
    period: "Sep 2025 – Present",
    colorClass: "color-1",
    points: [
      "Currently working as a Master's-level AI/ML intern, contributing to the design, development, and integration of intelligent AI agents and machine learning systems.",
      "Actively involved in training, fine-tuning, and evaluating machine learning models to support real-world AI-driven applications.",
      "Collaborate closely with data scientists and engineers to preprocess, analyze, and transform structured and unstructured data for effective model training.",
      "Support the deployment and integration of ML models through RESTful APIs and cloud-based infrastructure, gaining hands-on experience with production-grade AI workflows and DevOps practices.",
      "Technologies & Skills: Python, Machine Learning, AI Agents, Model Training & Evaluation, Google Cloud Platform (GCP), REST APIs, Data Preprocessing, DevOps, Team Collaboration",
    ],
  },
  {
    id: 2,
    role: "Full Stack + Devops (Software Manager)",
    company: "Agrocroft (GC Groups), Aarohfood.uk",
    companyUrl: "#",
    period: "Oct-2023 – Aug-2024",
    colorClass: "color-3",
    points: [
      "Developed an online grocery store from scratch using the MERN stack, featuring user authentication, product management, secure payment integration, and a responsive design.",
      "Implemented real-time inventory updates and optimized performance with AWS deployment and NGINX load balancing, ensuring seamless user experience and scalability for high traffic.",
    ],
  },
  {
    id: 3,
    role: "Full-Stack Developer",
    company: "Docfliq.com",
    companyUrl: "#",
    period: "Jun-2021 – Sep-2023",
    colorClass: "color-1",
    points: [
      "Created and Deployed New LMS, Managing and Optimizing and Implemented New Features in Current Running LMS of Docfliq.",
      "Directed a cross-functional team of 5 members in the planning, execution, and delivery of 2 high-impact projects, resulting in a 25% improvement in overall project efficiency.",
      "Oversaw project budgets, timelines, and resources, ensuring successful project completion within scope and on schedule.",
      "Implemented agile methodologies, leading to a 15% reduction in project delivery time and increased adaptability to changing project requirements.",
    ],
  },
  {
    id: 4,
    role: "Sr. Software Developer",
    company: "Appqik It Solutions And Technology Private Limited (appqik.us)",
    companyUrl: "#",
    period: "Jul-2019 – Dec-2020",
    colorClass: "color-2",
    points: [
      "Developed and maintained scalable and efficient code for three key modules in a School ERP system and Swimming Management Portal, contributing to a 30% improvement in system performance.",
      "Spearheaded the integration of new technologies, such as cloud services and containerization, into existing projects, leading to a 20% reduction in infrastructure costs.",
    ],
  },
  {
    id: 5,
    role: "Trainee Web Application Software Engineer",
    company: "Aeologic Private Limited (aeologic.com)",
    companyUrl: "#",
    period: "Aug-2018 – Dec-2018",
    colorClass: "color-3",
    points: [
      "Collaborated with a dynamic team to develop and maintain code for small-scale projects, gaining hands-on experience in Angular and PHP (Laravel).",
      "Actively participated in daily stand-up meetings, contributing ideas and solutions to improve project workflows and code efficiency.",
    ],
  },
];

export const projects = [
  {
    id: 1,
    title: "Latest Work",
    subtitle: "Aarohfood (An Ecomm Groccery App)",
    image: "/images/work4.png",
    link: "https://www.Aarohfood.uk",
    views: 107,
    likes: 9,
  },
  {
    id: 2,
    title: "Work 02",
    subtitle: "Docfliq (LMS)",
    image: "/images/work1.png",
    link: "https://www.docfliq.com",
    views: 130,
    likes: 27,
  },
  {
    id: 3,
    title: "Work 03",
    subtitle: "CMS (Construction Management Application)",
    image: "/images/work2.png",
    link: "#",
    views: 85,
    likes: 7,
  },
  {
    id: 4,
    title: "Work 04",
    subtitle: "TripTraveling Website",
    image: "/images/work3.png",
    link: "#",
    views: 80,
    likes: 4,
  },
];

export const blogPosts = [
  {
    id: 1,
    image: "/images/blog1.png",
    date: "Nov 01, 2023",
    category: "Web Design",
    likes: 9,
    title: "Kubernetes vs Docker: The Leading Tools",
    excerpt:
      "Both Docker and Kubernetes are two of the leading tools used in the cloud computing industry. Typically, Docker and Kubernetes are used in line with one another. However, Kubernetes vs Docker is the most popular topic in the cloud computing community.",
    link: "https://medium.com/@mynameischandangupta1",
  },
  {
    id: 2,
    image: "/images/blog2.png",
    date: "Oct 26, 2023",
    category: "Web Design",
    likes: 20,
    title: "Intro and Pratical of Terraform",
    excerpt:
      "The Infrastructure as Code (IaC) tools allow you to manage infrastructure with configuration files rather than through a graphical user interface. IaC allows you to build and manage your infra in a safe, consistent, and repeatable way by defining resource configurations that you can reuse and share with different providers.",
    link: "https://medium.com/@mynameischandangupta1",
  },
  {
    id: 3,
    image: "/images/blog3.png",
    date: "AUG 30, 2023",
    category: "Devops",
    likes: 4,
    title: "Install and Use Docker on Ubuntu",
    excerpt:
      "Docker is an application that simplifies the process of managing application processes in the form of containers. Containers will let you run your applications in resource-isolated processes. They are similar to virtual machines, but containers are more portable, more resource-friendly, and more dependent on the host operating system.",
    link: "https://medium.com/@mynameischandangupta1",
  },
];

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "achievements", label: "Achievement" },
  { id: "skills", label: "Skills" },
  { id: "education", label: "Education" },
  { id: "experience", label: "Experience" },
  { id: "work", label: "Work" },
  { id: "blog", label: "Blog" },
  { id: "contact", label: "Contact" },
];
